import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { FIRM_LOCATION, CONTACT } from "@/constants/content";

export const Footer = () => (
  <footer data-testid="site-footer" className="bg-[#0B1322] border-t border-white/5 overflow-hidden">
    <div className="max-w-7xl mx-auto px-6 lg:px-10 pt-24 pb-10">
      <div className="grid grid-cols-1 md:grid-cols-12 gap-12 mb-24">
        <div className="md:col-span-5">
          <p className="text-xs tracking-[0.25em] uppercase text-primary mb-6">Start the conversation</p>
          <Link
            to="/contact"
            data-testid="footer-contact-cta"
            className="inline-flex items-center gap-3 font-serif text-3xl sm:text-4xl font-light text-foreground hover:text-primary transition-colors duration-300"
          >
            Get in touch <ArrowUpRight className="w-7 h-7" />
          </Link>
        </div>
        <div className="md:col-span-3 md:col-start-7">
          <p className="text-xs tracking-[0.25em] uppercase text-muted-foreground mb-6">Navigate</p>
          <ul className="space-y-3">
            {[["/", "Home"], ["/about", "About"], ["/services", "Services"], ["/contact", "Contact"]].map(([to, label]) => (
              <li key={to}>
                <Link to={to} data-testid={`footer-link-${label.toLowerCase().replace(/\s+/g, "-")}`} className="text-sm text-muted-foreground hover:text-foreground transition-colors duration-300">
                  {label}
                </Link>
              </li>
            ))}
          </ul>
        </div>
        <div className="md:col-span-3">
          <p className="text-xs tracking-[0.25em] uppercase text-muted-foreground mb-6">Office</p>
          <p className="text-sm text-muted-foreground leading-relaxed">{FIRM_LOCATION}</p>
          <p className="text-sm text-muted-foreground leading-relaxed mt-2">Sunday – Thursday<br />10:00 AM – 4:00 PM</p>
          <div className="mt-6 space-y-2">
            <a href={`mailto:${CONTACT.email}`} data-testid="footer-email-link" className="block text-sm text-muted-foreground hover:text-primary transition-colors duration-300">{CONTACT.email}</a>
            <a href={CONTACT.phoneHref} data-testid="footer-phone-link" className="block text-sm text-muted-foreground hover:text-primary transition-colors duration-300">{CONTACT.phone}</a>
            <a href={CONTACT.instagram} target="_blank" rel="noopener noreferrer" data-testid="footer-instagram-link" className="block text-sm text-muted-foreground hover:text-primary transition-colors duration-300">Instagram {CONTACT.instagramHandle}</a>
          </div>
        </div>
      </div>

      <div className="select-none pointer-events-none" aria-hidden="true">
        <p className="font-serif font-light text-outline leading-[0.85] text-[16vw] md:text-[12vw] whitespace-nowrap tracking-tight">
          CLEAR HORIZON
        </p>
      </div>

      <div className="mt-10 pt-8 border-t border-white/5 flex flex-col sm:flex-row justify-between gap-4">
        <p className="text-xs text-muted-foreground">© {new Date().getFullYear()} Clear Horizon Consulting. Clarity today. Impact tomorrow.</p>
        <p className="text-xs text-muted-foreground">Organizational · Legal · Financial</p>
      </div>
    </div>
  </footer>
);
